import { useChangeProfilePasswordMutation } from '@common/cache';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { changePasswordSchema } from '../schema';
import { formatApiError } from '@common/errors/error-formatting.ts';

interface IChangePasswordFormShape {
  old_password: string;
  new_password: string;
  confirm_password: string;
}

const initialValues: IChangePasswordFormShape = {
  old_password: '',
  new_password: '',
  confirm_password: '',
};

export const useChangePasswordModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const changePasswordMutation = useChangeProfilePasswordMutation();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<IChangePasswordFormShape>({
    mode: 'onChange',
    resolver: yupResolver(changePasswordSchema),
    defaultValues: {
      ...initialValues,
    },
  });

  const submitHandler = async (values: IChangePasswordFormShape) => {
    try {
      await changePasswordMutation.mutateAsync({
        old_password: values.old_password,
        new_password: values.new_password,
      });

      onClose();

      toast.success('You successfully changed your password.');
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  const onSubmit = handleSubmit(submitHandler);

  return {
    onSubmit,
    control,
    showPassword,
    toggleShowPassword,
    isLoading: changePasswordMutation.isPending || isSubmitting,
  };
};
